<div class="container-fluid">
    <div class="row ">
      
        <div class="col-12 col-md-12 bgWhite padHeder mobView">
            <div class="col-6 col-md-6 pad0" style="display: inline-block;vertical-align: sub;">
                <span style="font-size: 20px; margin-right: 10px;">
                    <i class="fa fa-chevron-left"></i>
                </span>
            <h4 style="display: inline-block;">Valuation</h4>
            </div>
        </div>

        <div class="col-12 col-sm-12 bgWhite webView"  style="padding: 15px 15px 0px 13px;">
            <h3 style="display: inline-block;">
                Valuation
            </h3>
        </div>

      
        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px;">
            <div class="col-md-7 col-12 col-sm-12 " style="padding-top: 10px;padding-bottom: 10px;margin-bottom: 5px;border-radius: 0px;">
                <div class="col-md-5 col-5 col-sm-5" style="font-size: 17px;display: inline-block;padding: 0px;">
                    <span>select</span>
                </div>
                <div class="col-md-4 col-4 col-sm-4" style="font-size: 17px;display: inline-block;padding: 0px;text-align: right;">
                    <span>std</span>
                </div>        
            </div>
        </div>
     </div>
</div>
